














































import ContentContainer from './ContentContainer.vue';
import SearchField from './searchComponents/SearchField.vue';
import SearchFilter from './SearchFilter.vue';
import ErrorComponent from './ErrorComponent.vue';
import Loader from './Loader.vue';
import ImageComponent from './ImageComponent.vue';
import TestComponent from '@/components/testComponent.vue';
import { Component, Vue } from 'vue-property-decorator';
import loginService from '../services/loginService';
import { Getter, State } from 'vuex-class';
import { IError } from '../store/types/IRootState';


@Component({
  components: {
    SearchField,
    SearchFilter,
    ContentContainer,
    ErrorComponent,
    Loader,
    ImageComponent,
    TestComponent,
  },
})
export default class Main extends Vue {

  @Getter
  public getIsLoadingFlag!: boolean;
  @Getter
  public getError!: IError;
  @Getter
  public hasItems!: boolean;

  // @Mutation
  // public setGlobalLanguage: any;

  @State private hasFilters!: boolean;
  @State private hasEmptySearchResponse!: boolean;

  // public created() {
  //   this.setGlobalLanguage('pt'); // hardcoded, receive from integra's application.
  // }

  public showFiltersComponent() {
    return this.hasFilters;
  }
}
